import React, {useContext} from "react"

export const AppContext = React.createContext({})
export const AppProvider = AppContext.Provider

export const useCatalog = () => useContext(AppContext).catalog
export const useHelp = () => useContext(AppContext).help
export const useHelpCta = () => useContext(AppContext).helpCta
export const useMessage = () => useContext(AppContext).message
export const useModal = () => useContext(AppContext).modal
export const useProgress = () => useContext(AppContext).progress
export const useRoomParameters = () => useContext(AppContext).roomParameters
export const useRoomSetup = () => useContext(AppContext).roomSetup
export const useSolution = () => useContext(AppContext).solution
export const useSolutionRepository = () => useContext(AppContext).solutionRepository
export const useLocal = () => useContext(AppContext).local
export const useUrlQueryComponent = () => useContext(AppContext).urlQueryComponent
export const useLightbox = () => useContext(AppContext).lightbox
